import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Tabs, Tab, Stack, Alert } from '@mui/material'

import Layout from '../../common/components/Layout/Layout'
import ConnectionPanel from './sections/ConnectionPanel'
import IndexedDbHealthPanel from './sections/IndexedDbHealthPanel'
import SyncStatusPanel from './sections/SyncStatusPanel'
import CheckpointTimelinePanel from './sections/CheckpointTimelinePanel'
import LiveChecksPanel from './sections/LiveChecksPanel'
import ParityCheckPanel from './sections/ParityCheckPanel'
import SyncEventLogPanel from './sections/SyncEventLogPanel'

import './OfflineAudit.sass'

const TABS = [
  { id: 'connection', labelKey: 'audit_tab_connection', Component: ConnectionPanel },
  { id: 'indexeddb', labelKey: 'audit_tab_indexeddb', Component: IndexedDbHealthPanel },
  { id: 'sync_status', labelKey: 'audit_tab_sync_status', Component: SyncStatusPanel },
  { id: 'checkpoint_timeline', labelKey: 'audit_tab_checkpoint_timeline', Component: CheckpointTimelinePanel },
  { id: 'live_checks', labelKey: 'audit_tab_live_checks', Component: LiveChecksPanel },
  { id: 'parity', labelKey: 'audit_tab_parity', Component: ParityCheckPanel },
  { id: 'event_log', labelKey: 'audit_tab_event_log', Component: SyncEventLogPanel },
]

function OfflineAudit() {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState(TABS[0].id)

  const ActiveComponent = TABS.find(tab => tab.id === activeTab)?.Component

  return (
    <Layout className="OfflineAudit" style={{ padding: '0 34px 40px' }}>
      <Stack spacing={2}>
        <h1>{t('audit_page_title')}</h1>
        <Alert severity="warning">{t('audit_page_warning')}</Alert>

        <Tabs
          value={activeTab}
          onChange={(_, value) => setActiveTab(value)}
          variant="scrollable"
          scrollButtons="auto"
        >
          {TABS.map(tab => (
            <Tab key={tab.id} value={tab.id} label={t(tab.labelKey)} />
          ))}
        </Tabs>

        <div className="offline-audit-panel">
          {ActiveComponent && <ActiveComponent />}
        </div>
      </Stack>
    </Layout>
  )
}

export default OfflineAudit
